import { render, staticRenderFns } from "./PortionTile.vue?vue&type=template&id=8f488dda&"
import script from "./PortionTile.vue?vue&type=script&lang=ts&"
export * from "./PortionTile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports